import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import useStatusText from '@/hooks/use-status-text';
import getBadgeVariantByStatus from '@/utils/get-badge-variant-by-status';
import { hasVisibleStatus } from '../../../onboardings-shared/utils';
import useOnboardingTitle from '../../hooks/use-onboarding-title';
type OnboardingSummaryProps = {
  onboarding: EntityOnboarding;
  /** Leaves room at the end of the title for the action the strip lays over it. */
  hasAction?: boolean;
};
const toneClassName = {
  success: 'text-success',
  error: 'text-error',
  warning: 'text-warning',
  neutral: 'text-tertiary'
};
const OnboardingSummary = t0 => {
  const $ = _c(26);
  const {
    onboarding,
    hasAction
  } = t0;
  const statusT = useStatusText();
  const {
    formatDateWithTime
  } = useIntl();
  const getTitle = useOnboardingTitle();
  let t1;
  if ($[0] !== onboarding) {
    t1 = hasVisibleStatus(onboarding);
    $[0] = onboarding;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showStatus = t1;
  const tone = toneClassName[getBadgeVariantByStatus(onboarding.status)];
  const t2 = hasAction && "pr-5";
  let t3;
  if ($[2] !== t2) {
    t3 = cx("truncate text-label-3 text-primary", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== getTitle || $[5] !== onboarding) {
    t4 = getTitle(onboarding);
    $[4] = getTitle;
    $[5] = onboarding;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onboarding.status || $[11] !== showStatus || $[12] !== statusT || $[13] !== tone) {
    t6 = showStatus && <><span className={tone}>{statusT(onboarding.status)}</span><span aria-hidden={true}>·</span></>;
    $[10] = onboarding.status;
    $[11] = showStatus;
    $[12] = statusT;
    $[13] = tone;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== formatDateWithTime || $[16] !== onboarding.timestamp) {
    t7 = formatDateWithTime(new Date(onboarding.timestamp), {
      month: "short",
      year: "numeric"
    });
    $[15] = formatDateWithTime;
    $[16] = onboarding.timestamp;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <span className="truncate">{t7}</span>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <span className="flex min-w-0 items-center gap-1.5 text-caption-3 text-tertiary">{t6}{t8}</span>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t5 || $[24] !== t9) {
    t10 = <span className="flex min-w-0 flex-col gap-1 text-left">{t5}{t9}</span>;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default OnboardingSummary;